import React, { useState } from "react";
import { toast } from "react-toastify";

const TrainingLogin = ({ setShow }) => {
  const [data, setData] = useState({
    name: "",
    password: "",
  });

  const handleLogin = () => {
    if (Object.values(data).some((val) => val.trim() === "")) {
      toast.error("Kindly enter the name and password");
      return;
    }

    let { name, password } = data;
    if (name === "sakthi" && password === "Sakthi@123") {
      setShow(true);
      toast.success("Login sucessfull");
    } else {
      toast.error("Kindly enter correct credientials");
    }
  };

  return (
    <div className="d-flex ac-jc vh-100">
      <div className="col-md-4 card shawdow p-3 ">
        <h4 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22  me-3 my-3 ms-3 text-center primary">
          Login to continue
        </h4>
        <input
          type="text"
          className="input-box mb-3"
          value={data.name}
          onChange={(e) =>
            setData((prev) => ({
              ...prev,
              name: e.target.value,
            }))
          }
          placeholder="Enter the Name"
        />

        <input
          type="password"
          className="input-box mb-5"
          value={data.password}
          onChange={(e) =>
            setData((prev) => ({
              ...prev,
              password: e.target.value,
            }))
          }
          placeholder="Enter the password"
        />

        <button className="submit-btn" onClick={handleLogin}>
          Login
        </button>
      </div>
    </div>
  );
};

export default TrainingLogin;
